import React from 'react'
import './si.css';
import './si.js';

const ShortInfo = ({ setActiveComponent, handleDownload }) => {
    return (
        window.innerWidth > 768 ?
            < div className='row align-items-center  justify-content-center' style={{ marginTop: '13%' }
            }>

                {/* <h1>ShortInfo</h1> */}
                < div className='align-items-center col-md-12 ' >
                    <h1 className='hero_title typewrite '>
                        Dharmesh Poriya
                    </h1>
                    <div className="typing-container">
                        <h2>
                            <span id="sentence" className="sentence">I'm </span>
                            <span id="feature-text"></span>
                            <span className="input-cursor"></span>
                        </h2>
                    </div>
                </div >
                {/* <div className='col-md-4 border border-info fade-in-image'>
                <img className="w-100 hover-shadow" height={'500px'} src={myImage_1} alt='Dharmesh Poriya' />
            </div> */}
                < br />
                <br />
                <div className='col-12 m-5 ms-auto'>
                    {/* <button className='button-49' style={{marginRight:'15px'}} onClick={() => setActiveComponent('Contact')}>Get Hire?</button> */}
                    <button className='button-53' style={{ marginRight: '15px' }} onClick={() => setActiveComponent('Resume')}>Resume</button>
                    <button className='button-53' onClick={() => setActiveComponent('Contact')}>Get Hire?</button>
                </div>
            </div >
            :
            < div className='row align-items-center justify-content-center' style={{ marginTop: '40%', fontSize: '2.5rem', fontWeight: 200 }
            }>
                {/* <h1>ShortInfo</h1> */}
                < div className='align-items-center col-md-12' >
                    <h1 className='hero_title typewrite '>
                        Dharmesh Poriya
                    </h1>
                    <div className="typing-container">
                        <h2>
                            <span id="sentence" className="sentence">I'm </span>
                            <span id="feature-text"></span>
                            <span className="input-cursor"></span>
                        </h2>
                    </div>
                </div >
                {/* <div className='col-md-4 border border-info fade-in-image'>
                <img className="w-100 hover-shadow" height={'500px'} src={myImage_1} alt='Dharmesh Poriya' />
            </div> */}
                < br />
                <br />
                <div className='col-12 m-5 ms-auto mx-lg-0 mx-md-0 mx-sm-2 mx-3'>
                    {/* <button className='button-49'>Get Hire?</button> */}
                    <button className='button-53' style={{ marginRight: '15px' }} onClick={() => setActiveComponent('Resume')}>Resume</button>
                    <button className='button-53' onClick={() => setActiveComponent('Contact')}>Get Hire?</button>
                </div>
            </div >

    );
}

export default ShortInfo